module.exports = __webpack_public_path__ + "img/hat-wizard.94d0dccb.svg";